export default __webpack_public_path__ + "static/media/brainsprays-logo.c99119b4.webp";